module.exports = "/_next/static/images/close_alt-7fe90477fcbc5c5c514899d239c22c1e.svg";